import { render, staticRenderFns } from "./businessInfo.vue?vue&type=template&id=728a397c&scoped=true&"
import script from "./businessInfo.vue?vue&type=script&lang=js&"
export * from "./businessInfo.vue?vue&type=script&lang=js&"
import style0 from "./businessInfo.vue?vue&type=style&index=0&id=728a397c&scoped=true&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a397c",
  null
  
)

export default component.exports